export const setPartners = (payload) => ({
    type: 'SET_PARTNERS',
    payload
});

export const setSection = (payload) => ({
    type: 'SET_SECTION',
    payload
});

export const setRecruiterId = (payload) => ({
    type: 'SET_RECRUITER',
    payload
})

export const setClientId = (payload) => ({
    type: "SET_CLIENT",
    payload
})

export const setCeco = (payload) => ({
    type: "SET_CECO",
    payload
})

export const setPayrolls = (payload) => ({
    type: 'SET_PAYROLLS',
    payload
});

export const setSelectedStartDate = (payload) => ({
    type: 'SET_SELECTED_START_DATE',
    payload
});

export const setSelectedFinalDate = (payload) => ({
    type: 'SET_SELECTED_FINAL_DATE',
    payload
});


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/actions/index.js